"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightAlignFields = exports.TenantOption = exports.FrontType = exports.TenantConfigKey = exports.DefaultTenantConfigKey = exports.OPTION_ENABLED = void 0;
var accounting_1 = require("./accounting");
var robota_1 = require("./robota");
exports.OPTION_ENABLED = "1";
exports.DefaultTenantConfigKey = {
    INITIALIZE_LEVEL: "initializeLevel",
    PARTNER: "partner",
    PARTNER_FORMAT: "partnerFormat",
    TIMESTAMP_ENABLED: "timestampEnabled",
    FRONT_TYPE: "frontType",
    AWS_CLIENT_ID: "awsClientId",
    AWS_CLIENT_SECRET: "awsClientSecret",
    AWS_S3_REGION: "awsS3Region",
    AWS_S3_BUCKET: "awsS3Bucket",
    AUTO_JOURNAL_DETECT_ENABLED: "autoJournalDetectEnabled",
    AUTO_JOURNAL_DETECT_DATE_KEY: "autoJournalDetectDateKey",
    AUTO_JOURNAL_DETECT_AMOUNT_KEY: "autoJournalDetectAmountKey",
    AUTO_JOURNAL_DETECT_NOTE_KEY: "autoJournalDetectNoteKey",
    AUTO_JOURNAL_DETECT_ACCOUNT_TYPE_KEY: "autoJournalDetectAccountTypeKey",
    PARTNER_PULLDOWN_FORMAT: "partnerPulldownFormat",
    PARTNER_DISPLAY_FORMAT: "partnerDisplayFormat",
    DISTRIBUTION_ROBOTA_ENDPOINT: "distributionRobotaEndpoint",
    IS_DISTRIBUTION_ROBOTA_ENABLED: "isDistributionRobotaEnabled",
    HYPER_PASTE_VERSION: "hyperPasteVersion",
    BILLED_FROM_ENABLED: "billedFromEnabled",
    CONCUR_CLIENT_ID: "concurClientId",
    CONCUR_CLIENT_SECRET: "concurClientSecret",
    CONCUR_PDF_CONTENT_TYPE: "concurPdfContentType",
    INVOICE_SYSTEM_ENABLED: "invoiceSystemEnabled",
    ERRL_ENABLED: "errlEnabled",
    WAITING_TO_BE_ASSIGNED_ENABLED: "waitingToBeAssignedEnabled",
    OWNER_CODE: "ownerCode",
    ALLOWED_JOB_TYPES: "allowedJobTypes",
    APPROVAL_WORKFLOW_ENABLED: "approvalWorkflowEnabled",
    APPROVAL_WORKFLOW_WEBHOOK_URL: "approvalWorkflowWebhookUrl",
    APPROVAL_WORKFLOW_WEBHOOK_RQ_HEADER: "approvalWorkflowWebhookRequestHeader",
    EXPRESS_ENABLED: "expressEnabled",
    DASHBOARD_ENABLED: "dashboardEnabled",
    EXTERNAL_UPLOADER_ENABLED: "externalUploaderEnabled",
    MONTHLY_EXPECTED_NUMBER_OF_INVOICE: "monthlyExpectedNumberOfInvoice",
    ADDRESS_CODE_ALLOCATE_ENABLED: "destinationCodeAllocateEnabled",
    ADDRESS_CODE_TENANT_IDENTIFIER: "destinationCodeTenantIdentifier",
    FILE_ATTACHMENT_ENABLED: "fileAttachmentEnabled",
    USECASE: "usecase",
    AUTOMATIC_TAX_CALCULATION: "automaticTaxCalculation",
    AUTOMATIC_TAX_CALCULATION_CHOICE: "automaticTaxCalculationChoice",
    TARGET_PAGE_NUMBERS: "targetPageNumbers",
    SHORT_ID_PREFIX: "voucherSearchIdPrefix",
    VOUCHER_SEARCH_CSV_DOWNLOAD_ENABLED: "voucherSearchCsvDownloadEnabled",
    CUSTOM_FIELD_OCR: "customFieldOcr",
};
exports.TenantConfigKey = __assign(__assign({}, exports.DefaultTenantConfigKey), accounting_1.AccountingConfigKey);
var FrontType;
(function (FrontType) {
    FrontType["DEFAULT"] = "default";
    FrontType["DEMO"] = "demo";
    FrontType["CREDENTIAL"] = "credential";
    FrontType["EXPRESS"] = "express";
    FrontType["INSIDE"] = "inside";
})(FrontType = exports.FrontType || (exports.FrontType = {}));
var TenantOption;
(function (TenantOption) {
    TenantOption["BILLED_FROM"] = "BILLED_FROM";
    TenantOption["INVOICE_SYSTEM"] = "INVOICE_SYSTEM";
    TenantOption["ERRL"] = "ERRL";
    TenantOption["WAITING_TO_BE_ASSIGNED"] = "WAITING_TO_BE_ASSIGNED";
    TenantOption["IS_DISTRIBUTION_ENABLED"] = "IS_DISTRIBUTION_ENABLED";
    TenantOption["APPROVAL_WORKFLOW"] = "APPROVAL_WORKFLOW";
    TenantOption["HYPER_PASTE"] = "HYPER_PASTE";
    TenantOption["EXPRESS"] = "EXPRESS";
    TenantOption["DASHBOARD"] = "DASHBOARD";
    TenantOption["EXTERNAL_UPLOADER"] = "EXTERNAL_UPLOADER";
    TenantOption["ADDRESS_CODE_ALLOCATE"] = "ADDRESS_CODE_ALLOCATE";
    TenantOption["FILE_ATTACHMENT"] = "FILE_ATTACHMENT";
    TenantOption["VOUCHER_SEARCH_CSV_DOWNLOAD"] = "VOUCHER_SEARCH_CSV_DOWNLOAD";
    TenantOption["CUSTOM_FIELD_OCR"] = "CUSTOM_FIELD_OCR";
})(TenantOption = exports.TenantOption || (exports.TenantOption = {}));
exports.RightAlignFields = [robota_1.FieldType.AMOUNT, robota_1.FieldType.NUMBER];
